export enum LoaderType {
    LOADER_TYPE_IMAGE = "loader-image", // Display an image (gif, ex: running horse)
    LOADER_TYPE_SPINNER = "loader-spinner", // Display the default loader element (ex: infinite turning circle)
}
